/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$( document ).ready(function() {
    $("footer.Cart__Footer").addClass("mobile");
    $('.Cart__Footer.mobile span.Cart__NoteButton').click(function(){
     $( "textarea#cart-note" ).toggle(); 
	});
    $(window).scroll(function(){
      var sticky = $('footer.Cart__Footer'),
          scroll = $(window).scrollTop();

      if (scroll >= 100) sticky.addClass('fixed_bott');
      else sticky.removeClass('fixed_bott');
    });    
});


  $(document).ready(function(){
    //listen to the promo button click
    $('#redemDevPromo').on('click', function(event){
      //disable the button event
      event.preventDefault();
      //write the url format
      var theUrl = '/checkout?discount=';
      //grab the discount code from the input
      var theDiscount = $('#devPromo').val();
      console.log(theDiscount);
      //full url to redirect to checkout with promo code
      var toRedirect = theUrl+theDiscount;
      console.log(toRedirect);
      //redirect
      window.location.href = toRedirect;
    });
  });



 /*  gift for cart */


$(function() {
  $("input[name='attributes[Gift Message]']").click(function() {
      if ($("#yes-button3").is(":checked")) {
        $("#pers_meg").show();
        $("#pers_meg textarea").addClass('required');
        $("#pers_meg textarea").attr('required',true);
      } else {
        $("#pers_meg textarea").val('');
        $("#pers_meg").hide();
        $("#pers_meg textarea").removeClass('required');
        $("#pers_meg textarea").attr('required',false);
      }
    });
  
});

function main_yes() {
  $('.inner_personal').toggle();
}
//click function
$('.img_selc img').click(function(){
    $('.img_selc img').removeClass('active');
    $(this).addClass('active');
});

$(".persSticker").click(function() {
     console.log("sdjfh");
      if ($("#yes-button4").is(":checked")) {
        $("#pers_stiker").show();
        if($('#stickerUrl').val() == ''){
          
        }
        //$('#stickerUrl').val(defaultSticker);
      } else {
        removeSticker();
        $("#pers_stiker").hide();
        $("#image_variant").val('');
        $('.main_selc img').attr('src', '');
  		$('#stickerUrl').val('');
      }
});
  


$('.img_selc img').click(function(){
    $('.img_selc img').removeClass('active');
    $(this).addClass('active');
});

$( ".ProductListWrapper .product-card span.ProductItem__Label.Heading.Text--subdued:contains('LIMITED EDITION • SPECIAL VALUE')" ).addClass('removethistag');
$( ".sg60 span.ProductItem__Label.Heading.Text--subdued:contains('LIMITED EDITION • SPECIAL VALUE')" ).addClass('removethistag');
$( ".Product__Gallery .ProductItem__LabelList span.ProductItem__Label.Heading.Text--subdued:contains('LIMITED EDITION • SPECIAL VALUE')" ).addClass('removethistag');

/*$('.img_selc img').click(function(){
file_url = $(this).attr('src');
$('.main_selc img').attr('src', file_url);
  $('#stickerUrl').val(file_url);
});*/

/*  gift for cart */




/*  Shopify.Cart = Shopify.Cart || {};

  Shopify.Cart.GiftWrap = {};

  Shopify.Cart.GiftWrap.set = function() {
    var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: { {{ id }}: 1 }, attributes: { 'gift-wrapping': true } })
    };
    fetch('/cart/update.js', request)
    .then(function() {
      $(".wrap-product-cart").show();
      //location.href = '/cart';
    });
  }

  Shopify.Cart.GiftWrap.remove = function() {
    var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: { {{ id }}: 0 }, attributes: { 'gift-wrapping': '' } })
    };
    fetch('/cart/update.js', request)
    .then(function() {
      $(".wrap-product-cart").hide();
      $(".Cart__ItemList #item-40768713294017").hide();
      //location.href = '/cart';
    });
  }

  // If we have nothing but gift-wrap items in the cart.
  {% if cart.items.size == 1 and gift_wraps_in_cart > 0 %}
  console.log("only gift in cart");
  document.addEventListener("DOMContentLoaded", function(){
    Shopify.Cart.GiftWrap.remove();
  });
  // If we have more than one gift-wrap item in the cart.
  {% elsif gift_wraps_in_cart > 1 %}
  console.log("more gift in cart");
  document.addEventListener("DOMContentLoaded", function(){
    Shopify.Cart.GiftWrap.set();
  });
  // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
  
  {% elsif gift_wraps_in_cart > 0 %} 
     {% if cart.attributes.gift-wrapping == 'no' or cart.attributes.gift-wrapping == blank  %}
  		console.log("no gift attribute");
  		document.addEventListener("DOMContentLoaded", function(){
    		Shopify.Cart.GiftWrap.set();
        });
     {% endif %}
  
  
  // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
  {% elsif cart.attributes.gift-wrapping != 'no' and cart.attributes.gift-wrapping != blank %}
  	  {% if gift_wraps_in_cart == 0 %}
      console.log("no gift in cart");
      document.addEventListener("DOMContentLoaded", function(){
        Shopify.Cart.GiftWrap.set();
      });
  	{% endif %}
  {% endif %}
  
   
  
  
   $(".gift-wrapping").change(function(){
        var gift_wrap = $(".gift-wrapping:checked").val();
        if (gift_wrap == 'yes') {
        	Shopify.Cart.GiftWrap.set();
      	} else {
        	console.log("hbhh");
        	Shopify.Cart.GiftWrap.remove();
      	}

   });
  
  
  */

  

/* TL-4416 AOV upgrade */

window.atcModalLoaded = true;

(function() {

  function formatMoney(cents) {
    var fmt = window.theme && window.theme.moneyFormat;
    if (fmt) return fmt.replace('{{amount}}', (cents / 100).toFixed(2)).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    return (cents / 100).toFixed(2);
  }

  function closeModal() {
    var modal = document.getElementById('atc-modal');
    if (modal) modal.style.display = 'none';
  }

  function loadRecommendations(productId) {
    var wrapper = document.getElementById('atc-recs-wrapper');
    var recsEl = document.getElementById('atc-modal__recs');
    if (!recsEl) return;

    recsEl.innerHTML = '<p style="text-align:center;color:#888;font-size:12px;padding:10px;">Loading...</p>';

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=3&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || data.products.length === 0) {
          recsEl.innerHTML = '';
          return;
        }
        var html = '';
        data.products.forEach(function(p) {
          var img = (p.images && p.images[0])
            ? p.images[0].split('?')[0] + '?width=200'
            : '';
          var price = (p.variants && p.variants[0]) ? formatMoney(p.variants[0].price) : '';
          var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
          html +=
            '<div class="product-card-mini">' +
              '<a href="' + p.url + '">' +
                '<div class="pcm__img">' +
                  (img ? '<img src="' + img + '" alt="' + p.title + '">' : '') +
                '</div>' +
              '</a>' +
              '<div class="pcm__body">' +
                '<p class="pcm__title">' + p.title + '</p>' +
                '<p class="pcm__price">' + price + '</p>' +
                (variantId ?
                  '<form method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data">' +
                    '<input type="hidden" name="form_type" value="product">' +
                    '<input type="hidden" name="utf8" value="✓">' +
                    '<input type="hidden" name="id" value="' + variantId + '">' +
                    '<input type="hidden" name="quantity" value="1">' +
                    '<button type="submit" class="pcm__add" data-task="add-to-cart">Add to bag</button>' +
                  '</form>'
                : '') +
              '</div>' +
            '</div>';
        });
        recsEl.innerHTML = html;
        if (wrapper) wrapper.style.display = 'block';
      })
      .catch(function(err) {
        console.log('recommendations error:', err);
        recsEl.innerHTML = '';
      });
  }

  function openModal(variantId, productId, capturedImgSrc) {
    var modal = document.getElementById('atc-modal');
    if (!modal) return;

    document.getElementById('atc-modal__product').innerHTML =
      '<div class="atc-product">' +
        '<div class="atc-product__img"></div>' +
        '<div class="atc-product__info"><p class="atc-product__title">Loading...</p></div>' +
      '</div>';

    modal.style.display = 'flex';

    fetch('/variants/' + variantId + '.js')
      .then(function(r) { return r.json(); })
      .then(function(variant) {

        var subtitle = (variant.public_title && variant.public_title !== 'Default Title')
          ? '<p class="atc-product__sub">' + variant.public_title + '</p>'
          : '';

        document.getElementById('atc-modal__product').innerHTML =
          '<div class="atc-product">' +
            '<div class="atc-product__img" id="atc-product-img"></div>' +
            '<div class="atc-product__info">' +
              '<p class="atc-product__title">' + variant.name + '</p>' +
              subtitle +
              '<p class="atc-price">' + formatMoney(variant.price) + '</p>' +
            '</div>' +
          '</div>';

        if (variant.featured_image && variant.featured_image.src) {
          document.getElementById('atc-product-img').innerHTML =
            '<img src="' + variant.featured_image.src + '" alt="' + variant.name + '">';
        } else if (capturedImgSrc) {
          document.getElementById('atc-product-img').innerHTML =
            '<img src="' + capturedImgSrc + '" alt="' + variant.name + '">';
        }

        loadRecommendations(productId || variant.product_id);
      })
      .catch(function(err) {
        console.log('variant fetch error:', err);
      });
  }

  // Main ATC button — open modal
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[data-task="add-to-cart"], button[data-action="add-to-cart"]');
    if (!btn) return;
    if (btn.closest('#atc-modal')) return;

    var form = btn.closest('form');
    if (!form) return;

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    var variantId = variantInput.value;
    var productId = form.querySelector('[name="product-id"]')
      ? form.querySelector('[name="product-id"]').value
      : null;

    // Collection page: image URL baked into button by Liquid
    var capturedImgSrc = btn.getAttribute('data-product-image') || null;

    // Product page fallback: read from embedded product JSON
    if (!capturedImgSrc) {
      var jsonEl = document.querySelector('script[data-product-json]');
      if (jsonEl) {
        try {
          var productData = JSON.parse(jsonEl.textContent);
          var variantData = productData.product.variants.find(function(v) { return String(v.id) === String(variantId); });
          capturedImgSrc = (variantData && variantData.featured_image && variantData.featured_image.src)
            || productData.product.featured_image;
        } catch(e) {}
      }
    }

    setTimeout(function() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.Header__CartCount').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          document.querySelectorAll('.Header__CartDot').forEach(function(el) {
            cart.item_count > 0
              ? el.classList.add('is-visible')
              : el.classList.remove('is-visible');
          });
        });

      openModal(variantId, productId, capturedImgSrc);
    }, 800);
  });

  // Rec card button — animation only, theme handles cart
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pcm__add');
    if (!btn) return;

    btn.textContent = 'Adding...';
    btn.setAttribute('disabled', true);

    setTimeout(function() {
      btn.textContent = 'Added!';
      setTimeout(function() {
        btn.textContent = 'Add to bag';
        btn.removeAttribute('disabled');
      }, 1500);
    }, 800);
  });

  // Close listeners
  document.addEventListener('click', function(e) {

    if (e.target.id === 'atc-modal-close' || e.target.closest('#atc-modal-close')) {
      closeModal();
    }

    if (e.target.id === 'atc-modal-continue') {
      closeModal();
    }

    if (e.target.id === 'atc-modal') {
      closeModal();
    }

  });

})();


/**
 * cart-gwp-progressbar.js
 * Standalone GWP progress bar.
 */

(function () {
  'use strict';

  var _fetching = false;
  var _debounceTimer = null;

  function formatMoney(cents) {
    var amount = cents / 100;
    if (window.theme && window.theme.moneyFormat) {
      return window.theme.moneyFormat
        .replace('{{amount}}', amount.toFixed(2).replace(/\.00$/, ''))
        .replace('{{amount_no_decimals}}', Math.round(amount))
        .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount));
    }
    return amount.toFixed(2).replace(/\.00$/, '');
  }

  function getBars() {
    return document.querySelectorAll('[data-gwp-bar]');
  }

  // Tier amounts in cents, in the order the Liquid rendered them
  function getTiers(bar) {
    var nodes = bar.querySelectorAll('.js-gwp-marker');
    var tiers = [];

    Array.prototype.forEach.call(nodes, function (node) {
      tiers.push({
        el: node,
        amount: parseInt(node.getAttribute('data-gwp-amount'), 10) || 0,
        reward: node.getAttribute('data-gwp-reward') || '',
        title: node.getAttribute('data-gwp-title') || ''
      });
    });

    return tiers;
  }

  // Amounts out of order make the nodes overlap and the message name the wrong
  // gift. Liquid renders them in settings order, so say so loudly rather than
  // drawing a bar nobody can read.
  function warnIfUnsorted(tiers) {
    for (var i = 1; i < tiers.length; i++) {
      if (tiers[i].amount <= tiers[i - 1].amount) {
        console.error(
          '[cart-gwp-progressbar] Tier amounts must ascend. Got: ' +
          tiers.map(function (t) { return t.amount / 100; }).join(', ') +
          '. Fix them in Theme settings > Cart GWP Progress Bar.'
        );
        return;
      }
    }
  }

  function updateBar(bar, totalCents) {
    var msgTpl     = bar.getAttribute('data-gwp-msg') || 'Add {amount} to unlock {reward} free';
    var upgradeTpl = bar.getAttribute('data-gwp-upgrade') || 'Add {amount} to upgrade to {reward} instead';
    var doneTpl    = bar.getAttribute('data-gwp-done') || 'Your gift is unlocked - {reward}';
    var earnedTpl  = bar.getAttribute('data-gwp-earned') || '{reward} added to your bag - free';

    var tiers = getTiers(bar);
    if (!tiers.length) return;

    var fill      = bar.querySelector('.js-gwp-fill');
    var msgEl     = bar.querySelector('.js-gwp-msg-text');
    var earnedEl  = bar.querySelector('.js-gwp-earned');
    var earnedTxt = bar.querySelector('.js-gwp-earned-text');
    var totalEl   = bar.querySelector('.js-gwp-total');
    var targetEl  = bar.querySelector('.js-gwp-target');

    // First tier not yet reached, and the last one that has been. The track
    // runs to the former; the latter is the gift already in the bag.
    var next   = null;
    var earned = null;

    tiers.forEach(function (tier) {
      if (totalCents >= tier.amount) {
        earned = tier;
        tier.el.classList.add('is-reached');
      } else {
        tier.el.classList.remove('is-reached');
        if (!next) next = tier;
      }
    });

    // Once everything is reached the track still has to end somewhere, so it
    // ends on the top tier and reads full.
    var target = next || tiers[tiers.length - 1];
    if (!target.amount) return;

    var pct = Math.min((totalCents / target.amount) * 100, 100);

    // Bail early if nothing has changed - prevents unnecessary DOM writes
    // that would re-trigger the MutationObserver. Keyed on the target too,
    // because crossing a tier can leave the percentage untouched while the
    // whole scale changes underneath it.
    var stamp = target.amount + ':' + pct;
    if (fill && fill.getAttribute('data-pct') === stamp) return;

    if (fill) {
      fill.style.width = pct + '%';
      fill.setAttribute('data-pct', stamp);
    }

    // Only the tier being worked toward shows its thumbnail.
    tiers.forEach(function (tier) {
      tier.el.classList.toggle('is-active', tier === target);
    });

    if (msgEl) {
      if (!next) {
        msgEl.innerHTML = doneTpl.replace('{reward}', target.reward);
      } else {
        msgEl.innerHTML = (earned ? upgradeTpl : msgTpl)
          .replace('{amount}', formatMoney(next.amount - totalCents))
          .replace('{reward}', target.reward);
      }
    }

    // Confirmation row names the gift only - never its value.
    if (earnedEl) {
      if (earned && earned.title) {
        if (earnedTxt) earnedTxt.innerHTML = earnedTpl.replace('{reward}', earned.title);
        earnedEl.hidden = false;
      } else {
        earnedEl.hidden = true;
      }
    }

    // The left label is the real cart total, so past the top tier it reads
    // higher than the right one. That is intended - it is not a range.
    if (totalEl) totalEl.innerHTML = formatMoney(totalCents);
    if (targetEl) targetEl.innerHTML = formatMoney(target.amount);

    if (next) {
      bar.classList.remove('is-unlocked');
    } else {
      bar.classList.add('is-unlocked');
    }
  }

  function updateAllBars(totalCents) {
    getBars().forEach(function (bar) {
      updateBar(bar, totalCents);
    });
  }

  // Single /cart.js fetch with guard - will not fire if already in-flight
  function refreshFromServer() {
    // No bar on the page (feature off, or cart still empty) - nothing to
    // update, so do not spend a /cart.js call. The drawer observer stays
    // attached so the bar is picked up as soon as Liquid renders one.
    if (getBars().length === 0) return;
    if (_fetching) return;
    _fetching = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateAllBars(cart.total_price);
      })
      .catch(function () {})
      .finally(function () {
        _fetching = false;
      });
  }

  // Debounced wrapper - collapses rapid successive calls into one
  function debouncedRefresh() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(refreshFromServer, 300);
  }

  function initFromLiquid() {
    getBars().forEach(function (bar) {
      var total = parseInt(bar.getAttribute('data-cart-total'), 10) || 0;
      warnIfUnsorted(getTiers(bar));
      updateBar(bar, total);
    });
  }

  function observeDrawer() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;

    var observer = new MutationObserver(function (mutations) {
      // Ignore mutations that only touch our own bar elements
      var isOwnUpdate = mutations.every(function (m) {
        return m.target.closest && m.target.closest('[data-gwp-bar]') !== null;
      });
      if (isOwnUpdate) return;

      debouncedRefresh();
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  function listenForCartEvents() {
    document.addEventListener('product:added', function () {
      debouncedRefresh();
    });
  }

  function init() {
    initFromLiquid();
    observeDrawer();
    listenForCartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ==========================================================================
   Pill filter (collection page) - #555

   Pills are plain links to tag URLs, so filtering already works with JS off.
   This upgrades them to swap the grid in place, reusing the theme's own
   ?view=ajax collection view. Single-select: one tag at a time.
   ========================================================================== */
(function () {
  var pillRow = document.querySelector('[data-pill-filter]');

  if (!pillRow) {
    return;
  }

  var productsElement = document.querySelector('.CollectionInner__Products');

  if (!productsElement) {
    return;
  }

  function setActive(pill) {
    var pills = pillRow.querySelectorAll('.PillFilter__Item');

    for (var i = 0; i < pills.length; i++) {
      pills[i].classList.toggle('is-active', pills[i] === pill);
    }
  }

  function loadGrid(url, pill) {
    var separator = url.indexOf('?') === -1 ? '?' : '&';

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(url + separator + 'view=ajax', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Request failed');
        }

        return response.text();
      })
      .then(function (content) {
        var temp = document.createElement('div');
        temp.innerHTML = content;

        var grid = temp.querySelector('.shopify-section');

        if (!grid) {
          throw new Error('No grid in response');
        }

        productsElement.innerHTML = grid.innerHTML;
        window.history.pushState({ path: url }, '', url);
        setActive(pill);
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        var top = pillRow.getBoundingClientRect().top -
          parseInt(document.documentElement.style.getPropertyValue('--header-height') || 0, 10);

        if (top < 0) {
          window.scrollBy({ top: top, behavior: 'smooth' });
        }
      })
      .catch(function () {
        // Fall back to a normal page load rather than leaving the grid stale
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        window.location.href = url;
      });
  }

  pillRow.addEventListener('click', function (event) {
    var pill = event.target.closest('.PillFilter__Item');

    if (!pill || pill.classList.contains('is-active')) {
      return;
    }

    event.preventDefault();

    // Keep whatever sort the shopper already chose
    var sortBy = new URLSearchParams(window.location.search).get('sort_by');
    var url = pill.getAttribute('href') + (sortBy ? '?sort_by=' + encodeURIComponent(sortBy) : '');

    loadGrid(url, pill);
  });

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
